import styles from "./EmptyCartView.module.css";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import { Link } from "react-router-dom";

const EmptyCartView = () => {
  return (
    <div className={styles.emptyCartContainer}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <AddShoppingCartOutlinedIcon className={styles.icon} />
        </div>
        <h3 className={styles.title}>¡Tu carrito está vacío!</h3>
        <p className={styles.subtitle}>
          Comienza a llenarlo con todo lo que necesites 🎉
        </p>
        <Link to="/" className={`buttonMain ${styles.shopButton}`}>
          Comienza a Comprar
        </Link>
      </div>
    </div>
  );
};

export default EmptyCartView;
